// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__2Ny2S","icon":"styles_icon__14ZRX","separator":"styles_separator__wOCcl"};